import { render, staticRenderFns } from "./DetailGeneral.vue?vue&type=template&id=51f99948&"
import script from "./DetailGeneral.vue?vue&type=script&lang=js&"
export * from "./DetailGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports